<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Gestión de documentos - <small>{{ getName() }}</small>
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div :class="classDivFile">
            <PictureSelect
              :fileReason="Constants.KEY_NAME_REASON_BANK_CERTIFICATE"
              fileName="CertificadoBancario"
              buttonText="Adjuntar certificado bancario"
              buttonTextUpdate="Actualizar certificado bancario"
              :updatable="true"
              @fileForm="fillFileFormCerBan"
            />
          </div>

          <div :class="classDivFile">
            <div class="file-input">
              <md-datepicker
                v-if="!fileFormDesPag"
                :md-disabled-dates="disabledDates"
                v-model="dateExp"
              >
                <label>Seleccionar fecha de expedición</label>
              </md-datepicker>
              <h5 v-else>
                Desprendible a cargar: {{ dateExp.getUTCFullYear() }}
                {{ dateExp.getUTCMonth() + 1 }}
              </h5>
            </div>
            <PictureSelect
              :fileReason="Constants.KEY_NAME_REASON_PAY_STUB"
              :fileName="
                'DesprendiblePago' +
                  dateExp.getUTCFullYear() +
                  (dateExp.getUTCMonth() + 1)
              "
              buttonText="Agregar desprendible de pago"
              :updatable="true"
              @fileForm="fillFileFormDesPag"
            />
          </div>
          <div :class="classDivFile">
            <PictureSelect
              :fileReason="Constants.KEY_NAME_REASON_WORK_CERTIFICATE"
              fileName="CartaLaboral"
              buttonText="Adjuntar Carta Laboral"
              buttonTextUpdate="Actualizar Carta Laboral"
              :updatable="true"
              @fileForm="fillFileFormCarLab"
            />
          </div>
        </div>
        <div class="md-layout-item md-size-100 text-right">
          <md-button
            @click="updateDocuments()"
            class="md-raised md-primary mt-4"
            >Guardar</md-button
          >
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import Swal from "sweetalert2";
import axios from "axios";
import store from "../../store";
import Constants from "../../constants";
import PictureSelect from "../components/PictureSelect.vue";

export default {
  components: { PictureSelect },

  data() {
    return {
      cerBanDefault: "./img/capital77/file-icon.webp",
      carLabDefault: "./img/capital77/file-icon.webp",
      desPagDefault: "./img/capital77/file-icon.webp",
      dateExp: new Date(),
      disabledDates: date => {
        return Constants.daysOfDifference(new Date(), date) > 0;
      },
      capCityDocExp: null,
      capDomainDocType: null,
      fileFormCerBan: null,
      fileFormCarLab: null,
      fileFormDesPag: null,
      fileCarLab: null,
      fileCerBan: null,
      fileDesPag: null,
      fileNameCerBan: "Archivo",
      fileNameDesPag: "Archivo",
      fileNameCarLab: "Archivo",
      Constants: Constants,
      classDivFile:
        "md-layout-item text-center md-size-25 mx-auto md-xsmall-size-100"
    };
  },
  methods: {
    fillFileFormCerBan(value) {
      this.fileFormCerBan = value;
    },
    fillFileFormDesPag(value) {
      this.fileFormDesPag = value;
    },
    fillFileFormCarLab(value) {
      this.fileFormCarLab = value;
    },
    getName() {
      return Constants.getUserFullName();
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (e.target.name == "cerBan") {
        this.createImage(files[0], "cerBan");
      } else if (e.target.name == "desPag") {
        this.createImage(files[0], "desPag");
      } else if (e.target.name == "carLab") {
        this.createImage(files[0], "carLab");
      }
    },
    createImage(file, type) {
      let reader = new FileReader();
      let vm = this;
      var partsName = file.name.split(".");
      var extension = partsName[partsName.length - 1];

      if (type === "cerBan") {
        this.fileNameCerBan = file.name;
      } else if (type === "carLab") {
        this.fileNameCarLab = file.name;
      } else if (type === "desPag") {
        this.fileNameDesPag = file.name;
      }
      if (
        extension.toLowerCase() == "jpeg" ||
        extension.toLowerCase() == "png" ||
        extension.toLowerCase() == "jpg"
      ) {
        reader.onload = e => {
          if (type === "cerBan") {
            vm.fileCerBan = e.target.result;
            vm.fileFormCerBan.set(
              "files",
              file,
              "CertificadoBancario." + extension
            );
          } else if (type === "carLab") {
            vm.fileCarLab = e.target.result;
            vm.fileFormCarLab.set("files", file, "CartaLaboral." + extension);
          } else if (type === "desPag") {
            vm.fileDesPag = e.target.result;
            vm.fileFormDesPag.set(
              "files",
              file,
              "DesprendiblePago" +
                this.dateExp.getUTCFullYear() +
                (this.dateExp.getUTCMonth() + 1) +
                "." +
                extension
            );
          }
        };

        reader.readAsDataURL(file);
      } else if (file.size < 5000000) {
        reader.onload = e => {
          if (type === "cerBan") {
            vm.fileCerBan = "./img/capital77/file-check-icon.webp";
            vm.fileFormCerBan.set(
              "files",
              file,
              "CertificadoBancario." + extension
            );
          } else if (type === "carLab") {
            vm.fileCarLab = "./img/capital77/file-check-icon.webp";
            vm.fileFormCarLab.set("files", file, "CartaLaboral." + extension);
          } else if (type === "desPag") {
            vm.fileDesPag = "./img/capital77/file-check-icon.webp";
            vm.fileFormDesPag.set(
              "files",
              file,
              "DesprendiblePago" +
                this.dateExp.getUTCFullYear() +
                (this.dateExp.getUTCMonth() + 1) +
                "." +
                extension
            );
          }
        };

        reader.readAsDataURL(file);
      } else {
        Swal.fire({
          title: "Tamaño no permitido",
          text: "Sólo puedes cargar archivos menores a 5 Mb",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    updateDocuments() {
      this.updateCerBan();
    },
    updateCerBan() {
      if (this.fileFormCerBan)
        axios({
          url: store.state.backend + "/uploadUserFiles",
          method: "POST",
          data: this.fileFormCerBan,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data"
          }
        }).then(response => {
          this.updateCarLab();
        });
      else this.updateCarLab();
    },
    updateCarLab() {
      if (this.fileFormCarLab)
        axios({
          url: store.state.backend + "/uploadUserFiles",
          method: "POST",
          data: this.fileFormCarLab,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data"
          }
        }).then(response => {
          this.updateDesPag();
        });
      else this.updateDesPag();
    },
    updateDesPag() {
      if (this.fileFormDesPag)
        axios({
          url: store.state.backend + "/uploadUserFiles",
          method: "POST",
          data: this.fileFormDesPag,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data"
          }
        }).then(response => {
          Swal.fire({
            title: "Documentos actualizados",
            text: "Tus documentos se han actualizado satisfactoriamente.",
            confirmButtonClass: "md-button md-primary",
            buttonsStyling: false
          }).then(() => {
            this.$router.go();
          });
        });
      else
        Swal.fire({
          title: "Documentos actualizados",
          text: "Tus documentos se han actualizado satisfactoriamente.",
          confirmButtonClass: "md-button md-primary",
          buttonsStyling: false
        }).then(() => {
          this.$router.go();
        });
    },
    removeImage: function(type) {
      if (type === "cerBan") {
        this.fileCerBan = "";
        this.fileNameCerBan = "Archivo";
      } else if (type === "desPag") {
        this.fileDesPag = "";
        this.fileNameDesPag = "Archivo";
      } else if (type === "carLab") {
        this.fileCarLab = "";
        this.fileNameCarLab = "Archivo";
      }
    }
  },
  watch: {}
};
</script>
<style></style>
